import { render, staticRenderFns } from "./add_short_video_form.vue?vue&type=template&id=171dd92c&scoped=true"
import script from "./add_short_video_form.vue?vue&type=script&lang=js"
export * from "./add_short_video_form.vue?vue&type=script&lang=js"
import style0 from "./add_short_video_form.vue?vue&type=style&index=0&id=171dd92c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171dd92c",
  null
  
)

export default component.exports